<template>
  <svg
    height="15"
    viewBox="0 0 256 256"
    width="15"
    xmlns="http://www.w3.org/2000/svg"
    class="skill-icon"
    preserveAspectRatio="xMidYMid"
    :class="{ 'dark-mode-icon': isDarkMode }"
  >
    <defs>
      <linearGradient x1="99.991%" y1="-.011%" x2=".01%" y2="100.01%" id="a">
        <stop stop-color="#E44857" offset=".344%" />
        <stop stop-color="#C711E1" offset="46.89%" />
        <stop stop-color="#7F52FF" offset="100%" />
      </linearGradient>
    </defs>
    <path d="M256 256H0V0h256L128 127.949z" />
  </svg>
</template>

<script>
export default {
  name: "KotlinIcon",
  props: {
    isDarkMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.skill-icon {
  width: 24px;
  height: 24px;
  fill: #000000;
}

.dark-mode-icon {
  fill: #ffffff;
}
</style>
